import {Injectable} from '@angular/core';

import {RebatesCollectorAccountInputModel, SesService, TradingService} from '@spa/api';
import {Helper} from 'appShared/classes';
import {SesPermissionService} from 'appEntries/panel/services/ses-permission.service';
import {forkJoin} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClientAccountService {

    constructor(
        private readonly tradingService: TradingService,
        private readonly sesService: SesService,
        private readonly sesPermissionService: SesPermissionService,
    ) {
    }

    private getObservableByOldCollectorsAccount(oldRebatesCollectorAccount: string, rebatesCollectorAccount: string) {
        if (!oldRebatesCollectorAccount) {
            return Helper.createSuccessResponseObservable<any>(null);
        }

        return this.sesService.updateOffsetAccount(
            new RebatesCollectorAccountInputModel(oldRebatesCollectorAccount, rebatesCollectorAccount)
        );
    }

    public updateRebateCollectorAccount(accountId: number, rebatesCollectorAccount: string, oldRebatesCollectorAccount: string) {
        if (!this.sesPermissionService.hasSetMarkupPermission()) {
            return forkJoin([Helper.createSuccessResponseObservable<any>(null), Helper.createSuccessResponseObservable<any>(null)]);
        }

        return forkJoin([this.tradingService.activateCollectRebbatesByAccount(accountId),
            this.getObservableByOldCollectorsAccount(oldRebatesCollectorAccount, rebatesCollectorAccount)]);
    }
}
